<div class="verify" *ngIf="state as s">
  <h2 class="ss-page-title">Verify — {{ s.batchId }}</h2>

  <p class="verify__done" *ngIf="readOnly">This batch is finished ({{ s.status }}). Nothing more can be scanned.</p>
  <div *ngIf="readOnly && banner" class="verify__banner verify__banner--{{ banner.type }}">{{ banner.text }}</div>
  <div class="verify__scan" *ngIf="!readOnly">
    <input #scanInput class="verify__input"
           [(ngModel)]="barcode"
           (keydown.enter)="scan()"
           placeholder="Scan or enter barcode"
           autocomplete="off" autofocus />
    <div *ngIf="banner" class="verify__banner verify__banner--{{ banner.type }}">{{ banner.text }}</div>
  </div>

  <div class="bag-progress" *ngIf="isMpsBatch">
    <span *ngFor="let b of bagStatus" class="bag-chip" [class.bag-chip--done]="b.total > 0 && b.done === b.total"
          [attr.data-bag]="b.bagId">
      Bag {{ b.bagId }} · {{ b.patientName }} · {{ b.done }}/{{ b.total }}
    </span>
  </div>
  <app-issue-banner *ngIf="issue"
                    [issue]="issue"
                    (moveNow)="moveNow()"
                    (defer)="defer()"
                    (dismiss)="dismiss()"></app-issue-banner>

  <div class="verify__grid">
    <div *ngFor="let b of s.baskets; trackBy: trackByBasket"
         class="basket"
         (click)="openBatchDetail(b)"
         [class.basket--current]="b.basketNumber === currentBasket && !basketComplete(b)"
         [class.basket--complete]="basketComplete(b)"
         [class.basket--pulse]="b.basketNumber === pulseBasket"
         [class.basket--issue]="basketHasIssue(b)">
      <div class="basket__head">
        <span class="basket__num">#{{ b.basketNumber }}</span>
        <span class="basket__name">{{ b.patientName }}</span>
        <span class="basket__dob" *ngIf="b.patientDob">{{ b.patientDob | dob }}</span>
      </div>
      <ul class="basket__meds">
        <li *ngFor="let m of b.medications; trackBy: trackByMed"
            class="med"
            [class.med--verified]="m.verifyScanStatus === 'Verified'"
            [class.med--missing]="m.pickScanStatus === 'Missing'">
          <span class="med__mark" [ngSwitch]="markState(m)"
                [class.med__mark--ok]="markState(m) === 'verified'"
                [class.med__mark--missing]="markState(m) === 'missing'"
                [class.med__mark--awaiting]="markState(m) === 'awaiting'">
            <ng-container *ngSwitchCase="'verified'">✓</ng-container>
            <ng-container *ngSwitchCase="'missing'">✕</ng-container>
            <ng-container *ngSwitchCase="'awaiting'">●</ng-container>
            <ng-container *ngSwitchDefault>○</ng-container>
          </span>
          <span class="med__name">{{ m.medicationName }}</span>
          <span class="med__alt" *ngIf="m.isSubstitute">ALT</span>
          <app-med-badges [packSize]="m.packSize" [fullPacks]="m.fullPacks" [bagId]="m.bagId"
                          [marking]="m.marking" [doNotSubstitute]="m.doNotSubstitute"></app-med-badges>
        </li>
      </ul>
    </div>
  </div>

  <div class="verify__actions">
    <button class="btn btn-primary" (click)="finish()" *ngIf="!readOnly || finished"
            [disabled]="finishing || (!finished && !allBasketsComplete() && !s.hasUnresolvedIssues)">
      {{ finished ? 'Back to batch list' : 'Finish Verifying' }}
    </button>
    <button *ngIf="s.hasUnresolvedIssues && !readOnly" class="btn btn-warning" (click)="finish()">
      Resolve {{ s.unresolvedIssues.length }} issues
    </button>
    <button *ngIf="canReprintBags" class="btn btn-outline-secondary" data-test="reprint-bag-labels"
            (click)="openBagReprint()">
      Reprint bag labels
    </button>
  </div>
</div>

<app-bag-reprint-panel *ngIf="bagReprintBatch" [batch]="bagReprintBatch" (closed)="closeBagReprint()"></app-bag-reprint-panel>
